import Vue from 'vue'

export default Vue.extend({
  name: 'LegendListVertical',

  props: {
    series: {
      type: Array,
      default () {
        return []
      }
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LegendListVertical/legend-list-vertical.ts